module.exports = __webpack_public_path__ + "static/img/Junior-Paulo.6f983c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Junior-Paulo.jpg
// module id = cp2J
// module chunks = 0